
  import moment from 'moment';
  import { Component, Prop, Vue} from "vue-property-decorator";
  import { mcDate } from '@/utils';
  import { ServingLine } from '@/models';
  import { ServingLineViewModel } from '@/view-models';

  @Component
  export default class McServingLines extends Vue {
    @Prop() readonly servingLines!: ServingLine[]
    @Prop({default: ''}) readonly countField!: string

    get servingLineVms(): ServingLineViewModel[] {
      let result: ServingLineViewModel[] = [];
      this.servingLines.forEach(m => result.push(new ServingLineViewModel(m)));
      return result;
    }

    getCount(servingLine) {
      return servingLine[this.countField];
    }

    get hasLines() {
      return this.servingLines !== undefined && this.servingLines.length > 0;
    }
  }
